module.exports = __webpack_public_path__ + "img/qilin-stage1.06b913b2.png";